/**
 * WhatsApp messaging quota — POST gettotalremainingquota
 * Requires non-empty phonenoId (see api_d.har / contacts.har).
 */
import { apihubPost } from "./apihub";

const PATH = "/getInteractedCustomerDetail/gettotalremainingquota";

/**
 * @param {string|number|null|undefined} phoneNoId WhatsApp phone_number_id
 * @returns {Promise<{ success: boolean; remainingQuota?: number; usedQuota?: number; message?: string }>}
 */
export async function fetchTotalRemainingQuota(phoneNoId) {
  const phonenoId = phoneNoId != null ? String(phoneNoId).trim() : "";

  if (!phonenoId) {
    return {
      success: false,
      message: "phonenoId is required",
    };
  }

  try {
    const body = await apihubPost(PATH, { phonenoId });
    if (body && typeof body === "object" && body.success === false) {
      return body;
    }
    return body;
  } catch (err) {
    return {
      success: false,
      message: err.message || "Failed to fetch remaining quota",
    };
  }
}
